import i18n from 'i18next';

import { identityTranslations } from './index';

/**
 * Registers the translations of the domain. It runs once at start-up and not in the post-login
 * bootstrap, because the public routes of this domain render before anybody logs in.
 */
export const registerIdentityTranslations = (): void => {
  if (!i18n.addResourceBundle) return;

  Object.entries(identityTranslations).forEach(([language, resources]) => {
    i18n.addResourceBundle(language, 'identity', resources, true, true);
  });
};

/** Whether the translations are loaded, for the current language or the one given. */
export const areIdentityTranslationsLoaded = (language?: string): boolean => {
  if (!i18n.hasResourceBundle) return false;

  const lng = language || i18n.language;
  return i18n.hasResourceBundle(lng, 'identity');
};
